import { useCallback } from 'react';
import { useOpenDeeplink } from '../../../../hooks';
import { appendParams, finalizeUrl, getDefaultWebviewLink } from '../../utils';

/**
 * 상품 리뷰 목록으로 이동.
 *
 * 웹/네이티브 분기가 없는 이유: 아래에서 만드는 `ably://webview?url=/goods/{sno}/reviews` 는
 * `WEBVIEW_WRAPPED_NATIVE_SCREENS` 에 `GoodsReviewList` 가 등록돼 있어 `openDeeplink` 가
 * 알아서 전용 화면으로 push 한다(웹에서도 주소가 `/goods/{sno}/reviews` 로 유지된다).
 */
export const useMoveToReviewList = () => {
  const { openDeeplink } = useOpenDeeplink();

  return useCallback(
    (params: {
      goodsSno: number;
      beautyRecommendOptionsSno?: number;
      titleBar?: boolean;
    }) => {
      const searchParams = new URLSearchParams();

      if (params.beautyRecommendOptionsSno) {
        searchParams.append(
          'beauty_recommend_option_sno',
          `${params.beautyRecommendOptionsSno}`,
        );
      }

      const query = searchParams.toString();
      const path = `/goods/${params.goodsSno}/reviews${query ? `?${query}` : ''}`;

      const link = getDefaultWebviewLink(params.titleBar ?? false);
      appendParams(link, 'url', path);
      openDeeplink(finalizeUrl(link));
    },
    [openDeeplink],
  );
};
